"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var utils_1 = require("../utils");
var nativeScrollable_1 = require("../nativeScrollable");
var surface_1 = require("../surface");
var searchBar_1 = require("../searchBar");
var icon_1 = require("../icon");
var MultiSelect = /** @class */ (function (_super) {
    tslib_1.__extends(MultiSelect, _super);
    function MultiSelect(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSelect = function (value, group) {
            if (group === void 0) { group = []; }
            var onSelectionChange = _this.props.onSelectionChange;
            var selectedValue = _this.handleSelection(value, group);
            onSelectionChange(selectedValue);
            if (utils_1.isDefined(_this.state.value)) {
                _this.setState({
                    value: selectedValue
                });
            }
        };
        _this.isSelectedOption = function (label, value, currentSelectionValue) {
            var multiple = _this.props.multiple;
            var selectedValue = _this.value;
            return utils_1.isDefined(currentSelectionValue)
                ? currentSelectionValue
                : multiple
                    ? selectedValue.indexOf(value) > -1
                    : selectedValue === value;
        };
        _this.shouldShowOption = function (label, value) {
            var query = _this.state.query;
            if (!query) {
                return true;
            }
            return utils_1.multiWordFilter((label || value), query);
        };
        _this.onSearch = function (e) {
            _this.setState({
                query: e.target.value
            });
        };
        _this.onClearSearch = function () {
            _this.setState({ query: "" });
        };
        _this.nativeItems = [];
        _this.selectedGroup = null;
        _this.state = { value: props.defaultValue, query: "" };
        return _this;
    }
    MultiSelect.prototype.getChildContext = function () {
        return {
            onSelect: this.onSelect,
            multiple: this.props.multiple
        };
    };
    Object.defineProperty(MultiSelect.prototype, "value", {
        get: function () {
            if (utils_1.isDefined(this.state.value)) {
                return this.state.value;
            }
            return this.props.value;
        },
        enumerable: true,
        configurable: true
    });
    MultiSelect.prototype.isClickWithinTarget = function (target, ref) {
        return ref.contains(target);
    };
    MultiSelect.prototype.handleSelection = function (value, group) {
        var _a = this.props, multiple = _a.multiple, allowOnlySameGroupSelection = _a.allowOnlySameGroupSelection;
        var nextValue = value;
        if (multiple) {
            group = group[group.length - 1];
            if (allowOnlySameGroupSelection && group !== this.selectedGroup) {
                this.selectedGroup = group;
                return [value];
            }
            nextValue = [].concat(this.value);
            var idx = nextValue.indexOf(value);
            if (idx > -1) {
                nextValue.splice(idx, 1);
            }
            else {
                nextValue.push(value);
            }
        }
        return nextValue;
    };
    MultiSelect.prototype.addToNativeItems = function (label, value) {
        this.nativeItems.push({ label: label, value: value });
    };
    MultiSelect.prototype.renderList = function (children, group) {
        var _this = this;
        return React.Children.map(children, function (child) {
            switch (child.type.displayName) {
                case "MultiSelectOption":
                    _this.addToNativeItems(child.props.label, child.props.value);
                    var isSelected = _this.isSelectedOption(child.props.label, child.props.value, child.props.selected);
                    if (isSelected && group) {
                        _this.selectedGroup = group;
                    }
                    return _this.shouldShowOption(child.props.label, child.props.value)
                        ? React.cloneElement(child, {
                            selected: isSelected
                        })
                        : null;
                case "MultiSelectGroup":
                    var items = _this.renderList(child.props.children, child.props.value);
                    return items.length > 0
                        ? React.cloneElement(child, {
                            children: items
                        })
                        : null;
                default:
                    return null;
            }
        });
    };
    MultiSelect.prototype.getItemLabel = function (item) {
        return item.label || item.value;
    };
    MultiSelect.prototype.getItemValue = function (item) {
        return item.value || item.label;
    };
    MultiSelect.prototype.renderSearchBar = function () {
        var theme = this.props.theme;
        var query = this.state.query;
        return (React.createElement(searchBar_1.SearchBar, { fill: true, small: true, inner: true, autoFocus: true, value: query, className: theme.search, onChange: this.onSearch, onClear: this.onClearSearch }));
    };
    MultiSelect.prototype.renderEmptySearchMessage = function () {
        var theme = this.props.theme;
        return (React.createElement("div", { className: theme["empty-search-message"] },
            React.createElement(icon_1.Icon, { className: theme["empty-search-message-icon"], iconName: "icon-no-results", size: 4 }),
            React.createElement("div", { className: theme["empty-search-message-text"] },
                React.createElement("span", null, "Oops!"),
                " we couldn't",
                React.createElement("br", null),
                "find any results")));
    };
    MultiSelect.prototype.renderItemsList = function () {
        var _a = this.props, children = _a.children, theme = _a.theme, surfaceLevel = _a.surfaceLevel, searchable = _a.searchable, maxItems = _a.maxItems, itemHeight = _a.itemHeight;
        var query = this.state.query;
        var nativeScrollableProps = {
            suppressX: true
        };
        this.nativeItems = [];
        var items = this.renderList(children);
        if (!isNaN(maxItems) && maxItems && this.nativeItems.length > maxItems) {
            nativeScrollableProps.height = maxItems * itemHeight;
        }
        return (React.createElement(surface_1.default, { level: surfaceLevel, className: theme.surface },
            searchable ? this.renderSearchBar() : null,
            items.length > 0
                ? React.createElement(nativeScrollable_1.default, tslib_1.__assign({}, nativeScrollableProps), items)
                : this.renderEmptySearchMessage()));
    };
    MultiSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, theme = _a.theme, focus = _a.focus, invalid = _a.invalid, surfaceLevel = _a.surfaceLevel, innerRef = _a.innerRef, children = _a.children, searchable = _a.searchable, onSelectionChange = _a.onSelectionChange, maxItems = _a.maxItems, itemHeight = _a.itemHeight, allowOnlySameGroupSelection = _a.allowOnlySameGroupSelection, value = _a.value, defaultValue = _a.defaultValue, exposedRef = _a.exposedRef, others = tslib_1.__rest(_a, ["className", "theme", "focus", "invalid", "surfaceLevel", "innerRef", "children", "searchable", "onSelectionChange", "maxItems", "itemHeight", "allowOnlySameGroupSelection", "value", "defaultValue", "exposedRef"]);
        return (React.createElement("div", { className: theme.list },
            this.renderItemsList(),
            React.createElement("select", tslib_1.__assign({ onChange: utils_1.noop }, others, { value: this.value, ref: exposedRef }),
                React.createElement("option", null),
                this.nativeItems.map(function (x, i) { return React.createElement("option", { key: i, value: _this.getItemValue(x) }); }))));
    };
    MultiSelect.defaultProps = {
        surfaceLevel: 2,
        itemHeight: 3.7
    };
    MultiSelect.childContextTypes = {
        onSelect: PropTypes.func,
        multiple: PropTypes.bool
    };
    return MultiSelect;
}(React.Component));
exports.default = MultiSelect;
